import { LocationListRequest } from '../../../core/cms-api/models';
import { Pagination } from '../../../shared/models/list.page.model';
import { LocationFilter } from '../store/location.models';
import * as paginationConstants from '../../../shared/constants/pagination.constants';

export class LocationRequestUtil {
  static createLocationListRequest(
    operatorId: string,
    pagination?: Pagination | null,
    filter?: LocationFilter | null
  ): LocationListRequest {
    return {
      operatorId: operatorId,
      pageIndex: pagination?.pageIndex ?? 0,
      pageSize: pagination?.pageSize ?? paginationConstants.DefaultPageSize,
      addressContains: filter?.addressContains,
      cityContains: filter?.cityContains,
      countryContains: filter?.countryContains,
      nameContains: filter?.nameContains,
      minNumberOfConnectors: filter?.numberOfConnectors ? filter.numberOfConnectors[0] : undefined,
      maxNumberOfConnectors: filter?.numberOfConnectors ? filter.numberOfConnectors[1] : undefined,
      minGridSupplyInKwh: filter?.gridSupplyInKwh ? filter.gridSupplyInKwh[0] : undefined,
      maxGridSupplyInKwh: filter?.gridSupplyInKwh ? filter.gridSupplyInKwh[1] : undefined,
      minNumberOfTransactions: filter?.numberOfTransactions ? filter.numberOfTransactions[0] : undefined,
      maxNumberOfTransactions: filter?.numberOfTransactions ? filter.numberOfTransactions[1] : undefined,
      postalCodeContains: filter?.postalCodeContains,
      postalCodes : filter?.postalCodes,
      names: filter?.names,
      addresses: filter?.addresses,
      cities: filter?.cities,
      statuses: filter?.statuses,
      extendFirstPageWithLocationId: filter?.extendPageWithLocationId,
      withMetadate: filter?.withMetadata??true,
      excludeLocationId: filter?.excludeLocationId
    } as LocationListRequest;
  }
}
